import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import userProfile from "assets/images/user-profile.png";
import { useParams } from "react-router-dom";
import ArgonButton from "components/ArgonButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Avatar from "@mui/material/Avatar";
import { useNavigate } from "react-router-dom";
import ActivityList from "./components/ActivityList";
import ActivityChat from "./components/ActivityChat";
import { useState, useEffect } from "react";
import { getCreatedActivities } from "services/activityService";
import { CircularProgress } from "@mui/material";

function ActivityCreated() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [activities, setActivities] = useState([]);
  const [user, setUser] = useState(null);
  const [selectedActivity, setSelectedActivity] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getCreatedActivities(id)
      .then((data) => {
        // Transform the API data to match the expected format
        const transformedActivities = data.data.activities.map((activity) => ({
          _id: activity._id,
          name: activity.title,
          lastMessage: activity.lastMessage,
          lastMessageTime: activity.last_message_time,
          image: activity.image,
          participantCount: activity.participantCount,
        }));

        setActivities(transformedActivities);
        if (transformedActivities.length > 0) {
          setSelectedActivity(transformedActivities[0]);
        }
        setUser(data.data.user);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching activities:", error);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <ArgonBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress />
      </ArgonBox>
    );
  }

  return (
    <>
      <ArgonBox pb={3}>
        <ArgonButton
          color="white"
          onClick={() => navigate("/admin/user-history")}
        >
          <ArrowBackIcon sx={{ mr: 1 }} />
          <ArgonTypography variant="h5" fontWeight="medium">
            Back
          </ArgonTypography>
        </ArgonButton>
        <ArgonBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt={2}
          p={2}
          sx={{
            minHeight: "120px",
            backgroundColor: "#fff",
            position: "relative",
            borderRadius: 4,
          }}
        >
          <ArgonBox display="flex" alignItems="center" gap={2}>
            <Avatar src={user?.avatar || userProfile} />
            <ArgonTypography variant="h5" fontWeight="medium">
              {user?.name}
            </ArgonTypography>
          </ArgonBox>
        </ArgonBox>
        <ArgonBox display="flex" gap={2} mt={5}>
          <ActivityList
            activities={activities}
            selectedActivity={selectedActivity}
            setSelectedActivity={setSelectedActivity}
          />
          {selectedActivity && (
            <ActivityChat activity={selectedActivity} userId={id} />
          )}
        </ArgonBox>
      </ArgonBox>
    </>
  );
}

export default ActivityCreated;
